if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* ==========================================================================
   04/09/2026 — Rolvea. LE FOTO DEL COLORE SCELTO, E PRIMA DELLE ALTRE.

   Dalle registrazioni Clarity: scegli Bordeaux e le prime miniature sono blu
   navy. Misurato sul live prima di questo file: 404 coppie prodotto-colore su
   953 (42%, 50 schede) avevano la PRIMA miniatura di un altro colore.

   Non era il picker: la foto ATTIVATA era gia' quella giusta. E' l'ordine. Una
   variante dichiara UNA foto sua (`featured_media`); tutte le altre lo snippet
   `product-media-gallery.liquid` le attribuisce indovinando dall'alt, e chiede
   che l'alt della foto extra COMINCI con l'alt della hero. Quando non comincia
   il media resta `always_display` — visibile su tutti i colori — e siccome
   l'ordine e' quello di posizione, finisce IN TESTA.

   Due regole, tutte e due qui e non nello snippet: lo script inline della
   galleria fa gia' il filtro al cambio colore, questo gli mette davanti dati
   migliori e dietro un riordino. I due non si pestano i piedi (uno mette le
   classi `hidden`, l'altro sposta i nodi) e l'ordine in cui girano non conta.

   REGOLA 1 — il colore si legge anche DENTRO l'alt, non solo in testa.
     Su `body-classic-seconda-pelle` convivono due grammatiche di alt nella
     stessa scheda: la hero dice "Body manica lunga seamless Sculptline, colore
     Caffe' Scuro", le altre "Tuta Corta Manica Lunga Sculptline(tm) Seconda
     Pelle — Caffe' Scuro, indossato (3)". Stesso colore scritto dentro,
     prefisso diverso: tre foto Caffe' Scuro mostrate su OGNI colore, in
     posizione 2-3-4. Recupera 221 foto sulle 1053 non attribuite; le altre 802
     non hanno nessun indizio (alt generico, nomi file hash Alibaba) e li'
     l'unica strada e' guardarle.

   REGOLA 2 — prima la foto della variante, poi le altre del suo colore, poi
     quelle che non sappiamo di chi siano.
     🔴 Si SPOSTANO i nodi, non si usa `order`: provato, e il carosello di Dawn
     conta le pagine sull'ordine del DOM, quindi con `order` la miniatura col
     bordo e il contatore finivano su un'altra foto — lo stesso disallineamento
     che stiamo togliendo, spostato altrove.

   ⚠️ Il prezzo, misurato: le coppie prodotto-colore con una SOLA foto passano
   da 210 a 379. Attribuire una foto la toglie dal mucchio che riempiva le
   gallerie magre. Nessun colore resta senza foto proprie (verificato sui 117
   prodotti dove il filtro e' attivo), ma le foto per colore, quelle, vanno
   fatte.
   ========================================================================== */
(function () {
  var DONE = '__rlvAttributed';

  function nrm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ').trim();
  }

  function altOf(el) {
    var im = el.querySelector('img');
    return im ? (im.getAttribute('alt') || '') : '';
  }

  function slides(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.product__media-item'));
  }

  function thumbFor(root, id) {
    if (!id) return null;
    var ths = root.querySelectorAll('.thumbnail-list__item');
    for (var k = 0; k < ths.length; k++) {
      if (ths[k].getAttribute('data-target') === id) return ths[k];
    }
    return null;
  }

  function commonPrefix(list) {
    var p = list[0] || '';
    for (var i = 1; i < list.length; i++) {
      var s = list[i], k = 0;
      while (k < p.length && k < s.length && p.charAt(k) === s.charAt(k)) k++;
      p = p.slice(0, k);
      if (!p) break;
    }
    return p;
  }

  /* Separatori che restano attaccati al token dopo aver tolto il prefisso
     comune: " — ", ", ", " - ".
     🔴 Il trattino va IN FONDO alla classe: messo in mezzo sarebbe un
     intervallo da "/" a "–", cioe' cifre e mezzo alfabeto, e "Nero" verrebbe
     raso a zero. */
  function trimSep(s) {
    return (s || '').replace(/^[\s,;:.|/–—-]+/, '')
      .replace(/[\s,;:.|/–—-]+$/, '');
  }

  function currentValue(root) {
    var opt = root.getAttribute('data-rlv-optname') || '';
    var scope = document.getElementById('ProductInfo-' + (root.dataset.section || '')) || document;
    var sel = 'input[type=radio][name="options[' + opt + ']"]:checked';
    var r = scope.querySelector(sel) || document.querySelector(sel);
    if (r && r.value) return r.value.trim();
    var s = 'select[name="options[' + opt + ']"]';
    var d = scope.querySelector(s) || document.querySelector(s);
    return d && d.value ? d.value.trim() : null;
  }

  function setAlt(root, li, index, colore) {
    li.setAttribute('data-alt', colore);
    var th = thumbFor(root, li.getAttribute('data-media-id'));
    if (th) th.setAttribute('data-alt', colore);
    /* le pastiglie del paginatore non hanno un id media: si allineano per
       posizione, e solo se sono tante quante gli slide. */
    var dots = root.querySelectorAll('.slider-counter__link');
    if (dots.length && dots.length === slides(root).length && dots[index]) {
      dots[index].setAttribute('data-alt', colore);
    }
  }

  function attribuisci(root) {
    if (root[DONE]) return;
    root[DONE] = true;

    var list = slides(root);
    var colori = [], heroAlt = {}, altiNoti = [];
    list.forEach(function (li) {
      var c = li.getAttribute('data-alt');
      if (!c || c === 'always_display') return;
      if (colori.indexOf(c) < 0) colori.push(c);
      var a = altOf(li);
      if (a) {
        if (heroAlt[c] === undefined) heroAlt[c] = a;
        altiNoti.push({ c: c, a: nrm(a) });
      }
    });
    if (colori.length < 2) return;

    /* Il token si ricava dagli ALT, mai dal nome dell'opzione: su /en/ il valore
       del picker e' tradotto ("Dark Coffee") e l'alt no ("Caffe' Scuro"). Il
       nome dell'opzione resta solo come seconda pista, per le schede dove le
       hero non condividono nessun prefisso. */
    var pieni = colori.map(function (c) { return heroAlt[c] || ''; }).filter(Boolean);
    var lcp = pieni.length > 1 ? commonPrefix(pieni) : '';
    var toks = [];
    colori.forEach(function (c) {
      if (heroAlt[c]) {
        var t = nrm(trimSep(heroAlt[c].slice(lcp.length)));
        if (t.length >= 3) toks.push({ c: c, t: t });
      }
      var v = nrm(c);
      if (v.length >= 3) toks.push({ c: c, t: v });
    });

    toks = toks.filter(function (x) {
      /* un token che porta a due colori diversi non decide niente */
      if (toks.some(function (y) { return y.t === x.t && y.c !== x.c; })) return false;
      /* 🔴 la guardia che conta: se il token compare nell'alt di una foto che
         SAPPIAMO essere di un altro colore, non e' un nome di colore, e' una
         parola del titolo. Senza, una scheda intitolata "... — Bianco" con la
         variante "Bianco" si prenderebbe le foto di tutte le altre. */
      return !altiNoti.some(function (n) { return n.c !== x.c && n.a.indexOf(x.t) >= 0; });
    });
    if (!toks.length) return;

    list.forEach(function (li, i) {
      if (li.getAttribute('data-alt') !== 'always_display') return;
      var a = nrm(altOf(li));
      if (!a) return;
      var hit = toks.filter(function (x) { return a.indexOf(x.t) >= 0; });
      if (!hit.length) return;
      /* "Rosa" sta dentro "Rosa Cipria": vince il piu' lungo, e solo se gli altri
         gli stanno dentro. Se l'alt nomina due colori davvero diversi non si
         indovina: la foto resta visibile su tutti, che e' il modo giusto di
         sbagliare. */
      var w = hit.reduce(function (m, x) { return x.t.length > m.t.length ? x : m; }, hit[0]);
      if (hit.some(function (x) { return x.c !== w.c && w.t.indexOf(x.t) < 0; })) return;
      setAlt(root, li, i, w.c);
    });
  }

  function inView(el) {
    var ul = el && el.parentElement;
    if (!ul) return;
    if (ul.scrollWidth <= ul.clientWidth + 4) return;
    if (Math.abs(ul.scrollLeft - el.offsetLeft) <= 4) return;
    /* `scrollLeft = x` non sposta niente con scroll-behavior:smooth +
       scroll-snap: serve scrollTo chiedendo 'instant' per nome. */
    try { ul.scrollTo({ left: el.offsetLeft, behavior: 'instant' }); }
    catch (e) { ul.scrollLeft = el.offsetLeft; }
    if (Math.abs(ul.scrollLeft - el.offsetLeft) > 4) ul.scrollLeft = el.offsetLeft;
  }

  /* REGOLA 2. Rango: 0 la foto della variante, 1 le altre del suo colore, 2
     quelle non attribuite, 3 le nascoste. A parita' di rango si tiene l'ordine
     in cui stanno adesso, che e' quello di posizione del prodotto. */
  function sposta(root, sel, val, attId, idAttr) {
    var items = Array.prototype.slice.call(root.querySelectorAll(sel));
    if (items.length < 2) return;
    var ul = items[0].parentElement;
    if (!ul) return;
    var rango = function (el) {
      if (attId && idAttr && el.getAttribute(idAttr) === attId) return 0;
      var a = el.getAttribute('data-alt');
      if (a === val) return 1;
      return a === 'always_display' ? 2 : 3;
    };
    var voluto = items.slice().sort(function (a, b) {
      return rango(a) - rango(b) || items.indexOf(a) - items.indexOf(b);
    });
    for (var i = 0; i < items.length; i++) {
      if (items[i] !== voluto[i]) {          /* gia' in ordine: non si tocca */
        voluto.forEach(function (el) { ul.appendChild(el); });
        return;
      }
    }
  }

  /* 🔴 Il carosello tiene la sua lista di slide in una NodeList catturata
     all'avvio: spostare i nodi non la aggiorna, e da li' in poi conta le pagine
     con l'ordine vecchio. Misurato su `studio-layer-set-completo-3-pezzi`:
     sliderItemsToShow[0] era ancora una foto di un altro colore e la miniatura
     col bordo finiva sulla foto dopo. Si rimette la lista nell'ordine a schermo
     (nascoste in fondo) e si fa ricontare. */
  function risincronizza(root) {
    var v = root.querySelector('[id^="GalleryViewer"]');
    if (!v || !v.sliderItems || !v.sliderItems.length) return;
    try {
      v.sliderItems = Array.prototype.slice.call(v.sliderItems).sort(function (a, b) {
        var ha = a.clientWidth === 0, hb = b.clientWidth === 0;
        if (ha !== hb) return ha ? 1 : -1;
        return a.offsetLeft - b.offsetLeft;
      });
    } catch (e) {}
    if (v.initPages) { try { v.initPages(); } catch (e) {} }
    if (v.update) { try { v.update(); } catch (e) {} }
  }

  function ordina(root) {
    var val = currentValue(root);
    if (!val) return;
    var items = root.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
    var visibili = 0;
    items.forEach(function (el) {
      var a = el.getAttribute('data-alt');
      if (a === val || a === 'always_display') visibili++;
    });
    if (!visibili) {                     /* colore senza foto: si mostra tutto */
      items.forEach(function (el) { el.classList.remove('hidden'); });
      return;
    }
    items.forEach(function (el) {
      var a = el.getAttribute('data-alt');
      if (a === val || a === 'always_display') el.classList.remove('hidden');
      else el.classList.add('hidden');
    });

    /* l'attivo puo' essere rimasto su uno slide nascosto (e' la posizione 1 del
       prodotto, la classe la mette Liquid): si porta sulla prima foto del
       colore scelto. */
    var att = root.querySelector('.product__media-item.is-active');
    if (!att || att.classList.contains('hidden') || att.getAttribute('data-alt') !== val) {
      var prime = slides(root).filter(function (li) {
        return !li.classList.contains('hidden') && li.getAttribute('data-alt') === val;
      });
      if (!prime.length) {
        prime = slides(root).filter(function (li) { return !li.classList.contains('hidden'); });
      }
      if (!prime.length) return;
      var target = prime[0];
      var id = target.getAttribute('data-media-id');
      var y = window.pageYOffset;
      var fatto = false;
      if (id && typeof root.setActiveMedia === 'function') {
        try { root.setActiveMedia(id, false); fatto = true; } catch (e) {}
      }
      if (!fatto) {
        if (att) att.classList.remove('is-active');
        target.classList.add('is-active');
      }
      window.setTimeout(function () {
        if (Math.abs(window.pageYOffset - y) > 4) window.scrollTo(0, y);
      }, 80);
      att = target;
    }

    var attId = att.getAttribute('data-media-id');
    sposta(root, '.product__media-item', val, attId, 'data-media-id');
    sposta(root, '.thumbnail-list__item', val, attId, 'data-target');
    sposta(root, '.slider-counter__link', val, null, null);
    risincronizza(root);

    inView(att);
    var th = thumbFor(root, attId);
    if (th) {
      inView(th);
      /* la miniatura col bordo: senza questo resta su quella marcata da Liquid,
         cioe' la posizione 1 del prodotto, che ora sta in fondo. */
      if (typeof root.setActiveThumbnail === 'function') {
        try { root.setActiveThumbnail(th); } catch (e) {}
      }
    }
  }

  function passa() {
    document.querySelectorAll('media-gallery[data-rlv-auto]').forEach(function (root) {
      try { attribuisci(root); ordina(root); } catch (e) {}
    });
  }

  function dopo() {
    /* si ripete perche' anche Dawn scorre dentro un setTimeout, e la sua
       `onSlideChanged` e' in debounce a 500ms: se non si ripassa dopo, l'ultima
       parola sulla miniatura evidenziata resta sua. */
    window.setTimeout(passa, 0);
    window.setTimeout(passa, 140);
    window.setTimeout(passa, 620);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest &&
      e.target.closest('.product__info-wrapper, sticky-atc, variant-selects, variant-radios')) dopo();
  });
  document.addEventListener('shopify:section:load', dopo);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dopo);
  dopo();
})();